"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnemyDestroyedComponent = void 0;
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _eventBusComponent2 = require("../events/event-bus-component");
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _scene = /*#__PURE__*/new WeakMap();
var _group = /*#__PURE__*/new WeakMap();
var _eventBusComponent = /*#__PURE__*/new WeakMap();
class EnemyDestroyedComponent {
  constructor(scene, eventBusComponent) {
    _classPrivateFieldInitSpec(this, _scene, void 0);
    _classPrivateFieldInitSpec(this, _group, void 0);
    _classPrivateFieldInitSpec(this, _eventBusComponent, void 0);
    _classPrivateFieldSet(_scene, this, scene);
    _classPrivateFieldSet(_eventBusComponent, this, eventBusComponent);
    _classPrivateFieldSet(_group, this, _classPrivateFieldGet(_scene, this).add.group({
      name: "".concat(this.constructor.name, "-").concat(Phaser.Math.RND.uuid())
    }));
    _classPrivateFieldGet(_eventBusComponent, this).on(_eventBusComponent2.CUSTOM_EVENTS.ENEMY_DESTROYED, enemy => {
      const gameObject = _classPrivateFieldGet(_group, this).get(enemy.x, enemy.y, enemy.shipAssetKey, 0);
      gameObject.play({
        key: enemy.shipDestroyedAnimationKey
      });
    });
  }
}
exports.EnemyDestroyedComponent = EnemyDestroyedComponent;